import { useRef } from "react";
import { GameIcon } from "@/components/GameIcon";
import { HitGameFx } from "@/components/catalog/HitGameFx";

export const GAME_ACCENT = { pokemon: "#FF4438", riftbound: "#3b82f6", yugioh: "#8b5cf6" };
const GAME_TITLE = { pokemon: "#ffb4a8", riftbound: "#bcd6ff", yugioh: "#d6c6ff" };
const hexA = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

export const CatalogHeader = ({ games, active, onSelect }) => {
  const accent = GAME_ACCENT[active] || "#FF4438";
  const label = games.find((g) => g.key === active)?.label || "";
  const burstRef = useRef(null);
  return (
    <header className="sx relative isolate mb-5 lg:mb-8 lg:flex lg:items-end lg:justify-between lg:gap-8" data-testid="catalog-header">
      <div aria-hidden className="pointer-events-none absolute -top-24 -left-16 w-[420px] h-[320px] lg:w-[720px] lg:h-[420px] rounded-full blur-2xl transition-[background] duration-500"
        style={{ background: `radial-gradient(closest-side, ${hexA(accent, 0.22)}, transparent)` }} />
      <HitGameFx game={active} burstFrom={burstRef} />
      <div className="relative z-[1]">
        <div className="sx-label mb-2 whitespace-normal leading-[1.6] pr-2" data-testid="catalog-microlabel">Encuentra tus hits · Cartas, bundles y sellado</div>
        <h1 className="font-extrabold tracking-[-.05em] leading-[.92] text-[44px] sm:text-[56px] lg:text-[84px]" data-testid="catalog-title">
          Catálogo<br className="lg:hidden" /><span className="lg:ml-4 italic font-normal transition-[color,text-shadow] duration-[400ms]" data-testid="catalog-title-game"
            style={{ color: GAME_TITLE[active] || "rgba(255,255,255,.6)", textShadow: `0 0 28px ${hexA(accent, 0.55)}` }}>{label}</span>
        </h1>
      </div>
      <div className="relative z-[1] mt-4 lg:mt-0 flex gap-2 overflow-x-auto no-scrollbar -mx-4 px-4 lg:mx-0 lg:px-0" data-testid="catalog-game-tabs" role="tablist">
        {games.map((g) => {
          const on = g.key === active;
          const c = GAME_ACCENT[g.key] || g.color;
          return (
            <button key={g.key} ref={on ? burstRef : null} type="button" role="tab" aria-selected={on} onClick={() => onSelect(g.key)} data-testid={`catalog-game-tab-${g.key}`}
              className={`flex-none whitespace-nowrap inline-flex items-center gap-2 h-10 pl-1.5 pr-4 rounded-full border text-sm font-semibold transition-[background-color,border-color,color,box-shadow] duration-200 ${on ? "text-white" : "text-white/60 border-white/10 bg-[#101010] hover:text-white hover:border-white/25"}`}
              style={on ? { background: hexA(c, 0.15), borderColor: c, boxShadow: `0 0 22px ${hexA(c, 0.45)}` } : undefined}>
              <GameIcon game={g.key} size="sm" />
              {g.label}
            </button>
          );
        })}
      </div>
    </header>
  );
};

export const ActiveFilterChips = ({ chips, onClear }) => {
  if (!chips.length) return null;
  return (
    <div className="flex items-center gap-2 overflow-x-auto no-scrollbar -mx-4 px-4 lg:mx-0 lg:px-0 mb-4" data-testid="catalog-active-filters">
      {chips.map((c) => (
        <button key={c.key} type="button" onClick={c.remove} data-testid={`catalog-chip-remove-${c.key}`}
          className="flex-none whitespace-nowrap inline-flex items-center gap-1.5 h-8 px-3 rounded-full border border-[rgba(255,68,56,.5)] bg-[rgba(255,68,56,.1)] text-[#ff8a80] text-xs font-semibold hover:bg-[rgba(255,68,56,.2)] transition-colors">
          {c.label} <span aria-hidden>✕</span><span className="sr-only">Quitar filtro</span>
        </button>
      ))}
      <button type="button" onClick={onClear} className="flex-none text-xs text-white/60 underline underline-offset-2 hover:text-white px-1" data-testid="catalog-clear-filters-chips">Limpiar</button>
    </div>
  );
};
